export default "__VITE_ASSET__CrrWRwkS__"